import type { FC } from 'react';

import type { LoaderFunctionArgs } from '@remix-run/node';
import { json } from '@remix-run/node';
import { useLoaderData } from '@remix-run/react';

import { normalizeFeedView } from '~/constants/community';
import getPosts from '~/services/api/community/getPosts.server';
import { loaderSession } from '~/session';

import { CommunityFeed } from './_components/CommunityFeed';
import { hydrateAndFilterPosts } from './_utils/hydrateCommunityPosts.server';
import { shouldRevalidateCommunityRoute } from './_utils/shouldRevalidateCommunityRoute';

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const { session } = await loaderSession(request);
  const url = new URL(request.url);
  const view = normalizeFeedView(url.searchParams.get('view'));

  const postsResponse = await getPosts(request, session, { view });
  if (!postsResponse)
    return json({
      posts: [],
      pinnedPosts: [],
      meta: { has_more: false, next_cursor: null, limit: 25 },
    });

  return json(await hydrateAndFilterPosts(request, session, postsResponse));
};

export const shouldRevalidate = shouldRevalidateCommunityRoute;

const CommunityFeedRoute: FC = () => {
  const { posts, pinnedPosts, meta } = useLoaderData<typeof loader>();
  return <CommunityFeed initialPosts={posts} pinnedPosts={pinnedPosts} initialMeta={meta} />;
};

export default CommunityFeedRoute;
